/**
 * Warden ability clips. Owned by the warden animation work: define clips with `defineClip` (see
 * the commented example in ./blademaster.ts and the format in ../clips.ts) and register them in
 * `registerWardenClips`. Abilities not registered here play the class defaults (../defaults.ts).
 */
// import { ABILITY } from '@keystone/content';
// import { defineClip } from '../clips';
// import { registerAbilityClips } from '../registry';
import { registerWardenKit } from '../kits/warden';

export function registerWardenClips(): void {
  registerWardenKit(); // every warden ability: see ../kits/warden.ts
}
